import { useAtomValue } from "jotai";
import { useEffect, useRef } from "react";
import { beforeUnloadEventName } from "../../constants/env";
import { accessTokenAtom } from "../services/authentication-service/stores/access-token/access-token.store";
import { CanEscapeRefStore } from "../stores/app";

const beforeUnloadAction = (event: Event) => {
  const confirmationMessage = "o/";

  //@ts-ignore (in teoria returnValue è deprecato)
  event.returnValue = confirmationMessage; //Gecko + IE
  return confirmationMessage; //Webkit, Safari, Chrome
};

export function WindowBeforeUnload() {
  const canEscapeRef = useAtomValue(CanEscapeRefStore);
  const accessToken = useAtomValue(accessTokenAtom);
  const isMountedRef = useRef(true);

  useEffect(
    function setupBeforeUnloadListener() {
      if (!isMountedRef.current) return;
      if (!accessToken) {
        window.removeEventListener(beforeUnloadEventName, beforeUnloadAction);
        return;
      }
      if (!canEscapeRef) {
        window.removeEventListener(beforeUnloadEventName, beforeUnloadAction);
        return;
      }

      window.addEventListener(beforeUnloadEventName, beforeUnloadAction);
      return () => {
        window.removeEventListener(beforeUnloadEventName, beforeUnloadAction);
      };
    },
    [canEscapeRef, accessToken]
  );

  useEffect(function cleanupOnUnmount() {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return <></>;
}
